/* ============================================
   KIMAIA Strategic Quiz Engine v2
   6 psychologically optimized questions
   Bundle-first recommendation logic
   Correct KIMAIA bundles (maart 2026)
   ============================================ */

(function() {
  'use strict';

  /* --- Quiz Questions (6 strategic questions) --- */
  var kimaiaQuizQuestions = [
    {
      id: 'goal',
      question: 'Wat is je belangrijkste beautydoel?',
      subtitle: 'Kies wat het beste bij je past',
      options: [
        { value: 'glow', label: 'Stralende, gezonde glow', icon: '\u2728' },
        { value: 'anti-aging', label: 'Anti-aging & versteviging', icon: '\ud83c\udf3f' },
        { value: 'hydratatie', label: 'Diepe hydratatie & balans', icon: '\ud83d\udca7' },
        { value: 'alles', label: 'Ik wil het allemaal', icon: '\ud83d\udc8e' }
      ]
    },
    {
      id: 'leeftijd',
      question: 'In welke leeftijdscategorie val je?',
      subtitle: 'Dit helpt ons het beste advies te geven',
      options: [
        { value: '18-24', label: '18 \u2013 24', icon: '' },
        { value: '25-34', label: '25 \u2013 34', icon: '' },
        { value: '35-44', label: '35 \u2013 44', icon: '' },
        { value: '45+', label: '45+', icon: '' }
      ]
    },
    {
      id: 'huid',
      question: 'Hoe zou je jouw huid omschrijven?',
      subtitle: 'Denk aan hoe je huid er vandaag uitziet',
      options: [
        { value: 'droog', label: 'Droog & gevoelig', icon: '\ud83c\udf42' },
        { value: 'normaal', label: 'Normaal / combinatie', icon: '\ud83c\udf38' },
        { value: 'vettig', label: 'Vettig & onzuiver', icon: '\ud83c\udf0a' },
        { value: 'dof', label: 'Dof & vermoeid', icon: '\ud83d\ude34' }
      ]
    },
    {
      id: 'routine',
      question: 'Hoe ziet je huidige routine eruit?',
      subtitle: 'Wees eerlijk \u2014 er is geen fout antwoord',
      options: [
        { value: 'minimaal', label: 'Minimaal (1-2 producten)', icon: '\ud83e\udea5' },
        { value: 'basis', label: 'Basis (3-4 producten)', icon: '\ud83e\uddf4' },
        { value: 'uitgebreid', label: 'Uitgebreide routine', icon: '\ud83d\udc84' },
        { value: 'geen', label: 'Ik heb eigenlijk geen routine', icon: '\ud83e\udd37\u200d\u2640\ufe0f' }
      ]
    },
    {
      id: 'resultaat',
      question: 'Welk resultaat spreekt je het meest aan?',
      subtitle: 'Stel je voor over 30 dagen...',
      options: [
        { value: 'natuurlijk', label: 'Natuurlijke verbetering', icon: '\ud83c\udf3f' },
        { value: 'zichtbaar', label: 'Zichtbare transformatie', icon: '\ud83e\ude9e' },
        { value: 'maximaal', label: 'Maximaal resultaat', icon: '\ud83c\udfc6' },
        { value: 'beste', label: 'Het beste voor mijn huid', icon: '\ud83d\udc51' }
      ]
    },
    {
      id: 'focus',
      question: 'Waar ligt jouw focus?',
      subtitle: 'Dit bepaalt welke routine het beste past',
      options: [
        { value: 'huid', label: 'Mooie huid & glow', icon: '\u2728' },
        { value: 'energie', label: 'Energie & balans', icon: '\u26a1' },
        { value: 'sport', label: 'Sport & herstel', icon: '\ud83d\udcaa' },
        { value: 'totaal', label: 'Totaalpakket', icon: '\ud83c\udfaf' }
      ]
    }
  ];

  /* =============================================
     BUNDLE DATA — Bron: live shop (maart 2026)
     ============================================= */
  var kimaiaBundles = {
    'daily-glow-kit': {
      title: 'Daily Glow Kit',
      handle: 'daily-glow-kit',
      price: '90,00',
      oldPrice: '104,00',
      savings: '14',
      tag: 'Instapper',
      inhoud: 'Ocean Glow collageen, Valley Glow collageen, KIMAIA waterfles',
      beschrijving: 'Start jouw dag met stralende energie met deze complete basisroutine.'
    },
    'beauty-glow-kit': {
      title: 'Beauty Glow Kit',
      handle: 'beauty-glow-kit-1',
      price: '139,00',
      oldPrice: '163,00',
      savings: '24',
      tag: 'Meest gekozen',
      inhoud: 'Ocean Glow collageen, Valley Glow collageen, KIMAIA waterfles, KIMAIA facial cupping set',
      beschrijving: 'Premium skincare routine voor maximale glow en huidverbetering.'
    },
    'glow-balance-kit': {
      title: 'Glow & Balance Kit',
      handle: 'glow-balance-kit-1',
      price: '129,00',
      oldPrice: '153,00',
      savings: '24',
      tag: 'Populair',
      inhoud: 'Ocean Glow collageen, Valley Glow collageen, KIMAIA Algae Omega, KIMAIA waterfles',
      beschrijving: 'Glow van binnenuit gecombineerd met essentiele omega\u2019s voor balans.'
    },
    'protein-glow-kit': {
      title: 'Protein & Glow Kit',
      handle: 'protein-glow-kit-1',
      price: '129,00',
      oldPrice: '168,00',
      savings: '29',
      tag: 'Sport & Herstel',
      inhoud: 'Pure Earth proteine, Ocean Glow collageen, Valley Glow collageen, KIMAIA waterfles, KIMAIA shakeup',
      beschrijving: 'Voor spieropbouw, herstel en een stralende glow.'
    },
    'protein-glow-kit-vegan': {
      title: 'Protein & Glow Kit (Vegan)',
      handle: 'protein-glow-kit-copy',
      price: '129,00',
      oldPrice: '',
      savings: '',
      tag: 'Vegan Sport',
      inhoud: 'Vegan Vitality proteine, Ocean Glow collageen, Valley Glow collageen, KIMAIA waterfles, KIMAIA shakeup',
      beschrijving: 'Plantaardige kracht voor spieropbouw, herstel en glow.'
    },
    'vegan-power-kit': {
      title: 'Vegan Power Kit',
      handle: 'vegan-power-kit-1',
      price: '90,00',
      oldPrice: '',
      savings: '',
      tag: 'Vegan',
      inhoud: 'Volledig plantaardige KIMAIA routine',
      beschrijving: 'De ultieme vegan beauty routine.'
    }
  };

  /* =============================================
     LOSSE PRODUCTEN — Bron: live shop (maart 2026)
     Prijzen direct uit de Shopify storefront
     ============================================= */
  var kimaiaProducts = {
    'ocean-glow': {
      title: 'KIMAIA Ocean Glow Collagen',
      handle: 'kimaia-ocean-glow-collagen',
      price: '45,00'
    },
    'valley-glow': {
      title: 'KIMAIA Valley Glow Collagen',
      handle: 'kimaia-valley-glow-collagen',
      price: '45,00'
    },
    'algae-omega': {
      title: 'KIMAIA Algae Omega',
      handle: 'kimaia-algae-omega',
      price: '49,00'
    },
    'pure-earth': {
      title: 'KIMAIA Pure Earth Protein',
      handle: 'kimaia-pure-earth-protein',
      price: '40,00'
    },
    'vegan-vitality': {
      title: 'KIMAIA Vegan Vitality Protein',
      handle: 'kimaia-vegan-vitality-protein',
      price: '40,00'
    },
    'water-bottle': {
      title: 'KIMAIA Water Bottle',
      handle: 'kimaia-water-bottle',
      price: '14,00'
    },
    'facial-cupping': {
      title: 'KIMAIA Facial Cupping Set',
      handle: 'kimaia-facial-cupping-set',
      price: '59,00'
    },
    'shake-cup': {
      title: 'KIMAIA Shake Cup',
      handle: 'kimaia-shake-cup',
      price: '24,00'
    },
    'silk-gloss': {
      title: 'KIMAIA Silk Gloss',
      handle: 'kimaia-silk-gloss',
      price: '29,00'
    }
  };

  /* =============================================
     RECOMMENDATION LOGIC — Bundle-first
     Geen losse producten als primaire keuze
     ============================================= */
  function getRecommendation(answers) {
    var focus = answers.focus || 'huid';
    var goal = answers.goal || 'glow';
    var resultaat = answers.resultaat || 'natuurlijk';

    var rec = {
      mainBundle: null,
      upgradeBundle: null,
      headline: '',
      explanation: '',
      socialProof: '',
      mostChosen: false
    };

    /* --- Sport / herstel focus --- */
    if (focus === 'sport') {
      rec.mainBundle = kimaiaBundles['protein-glow-kit'];
      rec.upgradeBundle = kimaiaBundles['protein-glow-kit-vegan'];
      rec.headline = 'Jouw sport & herstel routine';
      rec.explanation = 'Op basis van je antwoorden raden we de Protein & Glow Kit aan. Perfect voor spieropbouw, snel herstel \u00e9n een stralende glow.';
      rec.socialProof = '89% van sportieve vrouwen kiest deze kit';
      return rec;
    }

    /* --- Energie / balans focus --- */
    if (focus === 'energie' || goal === 'hydratatie') {
      rec.mainBundle = kimaiaBundles['glow-balance-kit'];
      rec.upgradeBundle = kimaiaBundles['beauty-glow-kit'];
      rec.headline = 'Jouw balans & energie routine';
      rec.explanation = 'De Glow & Balance Kit combineert collageen met Algae Omega voor glow van binnenuit \u00e9n energie. Ideaal voor jouw doelen.';
      rec.socialProof = '91% ervaart meer energie binnen 3 weken';
      return rec;
    }

    /* --- Maximaal resultaat / alles tegelijk / totaal --- */
    if (goal === 'alles' || resultaat === 'maximaal' || resultaat === 'beste' || focus === 'totaal') {
      rec.mainBundle = kimaiaBundles['beauty-glow-kit'];
      rec.upgradeBundle = kimaiaBundles['glow-balance-kit'];
      rec.headline = 'De ultieme KIMAIA routine';
      rec.explanation = 'Jij gaat voor het beste \u2014 en dat verdien je. De Beauty Glow Kit is onze meest complete skincare routine voor maximale glow en huidverbetering.';
      rec.socialProof = '96% van onze premium klanten herbestelt binnen 30 dagen';
      rec.mostChosen = true;
      return rec;
    }

    /* --- Huid / glow focus (default) --- */
    if (focus === 'huid' || goal === 'glow' || goal === 'anti-aging') {
      rec.mainBundle = kimaiaBundles['beauty-glow-kit'];
      rec.upgradeBundle = kimaiaBundles['daily-glow-kit'];
      rec.headline = 'Jouw persoonlijke glow-routine';
      rec.explanation = 'De Beauty Glow Kit is samengesteld voor maximale glow en huidverbetering. Inclusief facial cupping voor een zichtbaar resultaat.';
      rec.socialProof = '92% ziet zichtbaar resultaat binnen 4 weken';
      rec.mostChosen = true;
      return rec;
    }

    /* --- Fallback: Daily Glow Kit als starter --- */
    rec.mainBundle = kimaiaBundles['daily-glow-kit'];
    rec.upgradeBundle = kimaiaBundles['beauty-glow-kit'];
    rec.headline = 'Jouw startpunt voor stralende huid';
    rec.explanation = 'De Daily Glow Kit is het perfecte startpunt. Een complete basisroutine met alles wat je huid nodig heeft.';
    rec.socialProof = '87% van nieuwe klanten begint hiermee';
    return rec;
  }

  /* --- Quiz State --- */
  var quizState = { step: 0, answers: {}, started: false, done: false };

  /* --- Render Quiz Step --- */
  function renderQuizStep(container, stepIndex) {
    var q = kimaiaQuizQuestions[stepIndex];
    if (!q) return;
    var totalSteps = kimaiaQuizQuestions.length;
    var progressPct = ((stepIndex) / totalSteps) * 100;
    var html = '<div class="kmq-step" data-step="' + stepIndex + '">';
    html += '<div class="kmq-progress"><div class="kmq-progress-bar" style="width:' + progressPct + '%"></div></div>';
    html += '<div class="kmq-step-count">Vraag ' + (stepIndex + 1) + ' van ' + totalSteps + '</div>';
    html += '<h3 class="kmq-question">' + q.question + '</h3>';
    if (q.subtitle) html += '<p class="kmq-question-sub">' + q.subtitle + '</p>';
    html += '<div class="kmq-options">';
    for (var i = 0; i < q.options.length; i++) {
      var opt = q.options[i];
      html += '<button class="kmq-option" data-question="' + q.id + '" data-value="' + opt.value + '">';
      if (opt.icon) html += '<span class="kmq-option-icon">' + opt.icon + '</span>';
      html += '<span class="kmq-option-label">' + opt.label + '</span></button>';
    }
    html += '</div></div>';
    container.innerHTML = html;
    var stepEl = container.querySelector('.kmq-step');
    if (stepEl) {
      stepEl.style.opacity = '0';
      stepEl.style.transform = 'translateY(15px)';
      setTimeout(function() {
        stepEl.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        stepEl.style.opacity = '1';
        stepEl.style.transform = 'translateY(0)';
      }, 50);
    }
    var options = container.querySelectorAll('.kmq-option');
    for (var j = 0; j < options.length; j++) {
      options[j].addEventListener('click', function(e) {
        var btn = e.currentTarget;
        var questionId = btn.getAttribute('data-question');
        var value = btn.getAttribute('data-value');
        var siblings = btn.parentNode.querySelectorAll('.kmq-option');
        for (var k = 0; k < siblings.length; k++) siblings[k].classList.remove('kmq-option--selected');
        btn.classList.add('kmq-option--selected');
        quizState.answers[questionId] = value;
        setTimeout(function() {
          quizState.step++;
          if (quizState.step < kimaiaQuizQuestions.length) renderQuizStep(container, quizState.step);
          else { quizState.done = true; renderQuizResult(); }
        }, 350);
      });
    }
  }

  /* --- Render Result Page --- */
  function renderQuizResult() {
    var resultContainer = document.getElementById('tvkQuizResult');
    var quizContainer = document.getElementById('tvkQuiz');
    if (!resultContainer) return;
    if (quizContainer) quizContainer.style.display = 'none';
    resultContainer.style.display = 'block';

    var rec = getRecommendation(quizState.answers);
    var bundle = rec.mainBundle;
    var upgrade = rec.upgradeBundle;

    var html = '<div class="kmq-result">';

    /* --- "Meest gekozen" badge --- */
    if (rec.mostChosen) {
      html += '<div style="text-align:center;margin-bottom:12px;"><span style="display:inline-block;padding:5px 16px;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#fff;background:linear-gradient(135deg,#c9a84c,#b8965a);border-radius:20px;">MEEST GEKOZEN: COMPLETE ROUTINE</span></div>';
    }

    /* --- Result header --- */
    html += '<div class="kmq-result-header">';
    html += '<div class="kmq-result-check">\u2713</div>';
    html += '<h3 class="kmq-result-title">' + rec.headline + '</h3>';
    html += '<p class="kmq-result-explain">' + rec.explanation + '</p></div>';

    /* --- Hoofdadvies: BUNDEL (altijd!) --- */
    if (bundle) {
      html += '<div class="kmq-result-product kmq-result-product--main">';
      html += '<div class="kmq-result-product-badge">' + bundle.tag + '</div>';
      html += '<h4 class="kmq-result-product-title">' + bundle.title + '</h4>';
      html += '<p class="kmq-result-product-price">\u20ac ' + bundle.price;
      if (bundle.oldPrice) {
        html += ' <span style="text-decoration:line-through;color:#a09080;font-weight:400;font-size:13px;">\u20ac ' + bundle.oldPrice + '</span>';
      }
      if (bundle.savings) {
        html += ' <span style="color:#4a8f3f;font-size:12px;font-weight:600;">Bespaar \u20ac' + bundle.savings + '</span>';
      }
      html += '</p>';
      html += '<p style="font-size:12px;color:#8a7d70;margin:0 0 14px;line-height:1.5;">Inhoud: ' + bundle.inhoud + '</p>';
      html += '<a href="/products/' + bundle.handle + '" class="kmq-result-btn kmq-result-btn--primary">Bekijk deze kit</a>';
      html += '</div>';
    }

    /* --- Upgrade bundel suggestie --- */
    if (upgrade && upgrade.handle !== bundle.handle) {
      html += '<div class="kmq-result-bundle">';
      html += '<div class="kmq-bundle-badge">OOK INTERESSANT</div>';
      html += '<p class="kmq-bundle-text">' + upgrade.title + ' \u2014 \u20ac' + upgrade.price + '</p>';
      html += '<p style="font-size:12px;color:#8a7d70;margin:0 0 10px;">' + upgrade.beschrijving + '</p>';
      if (upgrade.savings) {
        html += '<p class="kmq-bundle-savings">Bespaar \u20ac' + upgrade.savings + ' t.o.v. losse producten</p>';
      }
      html += '<a href="/products/' + upgrade.handle + '" class="kmq-result-btn kmq-result-btn--secondary">Bekijk kit \u2192</a>';
      html += '</div>';
    }

    /* --- Losse producten uit de bundel --- */
    html += '<div style="margin-top:20px;padding-top:16px;border-top:1px solid rgba(184,150,90,0.12);">';
    html += '<p style="font-size:13px;font-weight:600;color:#6b5e52;text-align:center;margin:0 0 12px;">Of bekijk de losse producten:</p>';

    /* Bepaal welke losse producten relevant zijn op basis van de bundel */
    var loosProducts = [];
    if (bundle && bundle.handle) {
      /* Altijd Ocean Glow + Valley Glow tonen */
      loosProducts.push(kimaiaProducts['ocean-glow']);
      loosProducts.push(kimaiaProducts['valley-glow']);

      /* Bundel-specifieke producten */
      if (bundle.handle === 'beauty-glow-kit-1') {
        loosProducts.push(kimaiaProducts['facial-cupping']);
      }
      if (bundle.handle === 'glow-balance-kit-1') {
        loosProducts.push(kimaiaProducts['algae-omega']);
      }
      if (bundle.handle === 'protein-glow-kit-1') {
        loosProducts.push(kimaiaProducts['pure-earth']);
        loosProducts.push(kimaiaProducts['shake-cup']);
      }
      if (bundle.handle === 'protein-glow-kit-copy') {
        loosProducts.push(kimaiaProducts['vegan-vitality']);
        loosProducts.push(kimaiaProducts['shake-cup']);
      }
    }

    for (var lp = 0; lp < loosProducts.length; lp++) {
      var prod = loosProducts[lp];
      if (!prod) continue;
      html += '<div class="kmq-result-product">';
      html += '<h4 class="kmq-result-product-title" style="font-size:15px;">' + prod.title + '</h4>';
      html += '<p class="kmq-result-product-price" style="font-size:14px;">\u20ac ' + prod.price + '</p>';
      html += '<a href="/products/' + prod.handle + '" class="kmq-result-btn kmq-result-btn--secondary" style="padding:8px 20px;font-size:12px;">Bekijk product</a>';
      html += '</div>';
    }
    html += '</div>';

    /* --- Social proof --- */
    html += '<div class="kmq-result-social">';
    html += '<span class="kmq-social-icon">\u2733</span> ' + rec.socialProof;
    html += '</div>';

    /* --- Trust footer --- */
    html += '<div class="kmq-result-trust">';
    html += '<span>Gratis verzending vanaf \u20ac50</span>';
    html += '<span>\u00b7</span>';
    html += '<span>14 dagen retour</span>';
    html += '<span>\u00b7</span>';
    html += '<span>Veilig betalen</span>';
    html += '</div>';

    html += '</div>';
    resultContainer.innerHTML = html;

    /* Fade in */
    var resultEl = resultContainer.querySelector('.kmq-result');
    if (resultEl) {
      resultEl.style.opacity = '0';
      resultEl.style.transform = 'translateY(15px)';
      setTimeout(function() {
        resultEl.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        resultEl.style.opacity = '1';
        resultEl.style.transform = 'translateY(0)';
      }, 100);
    }
  }

  /* --- Initialize --- */
  function initKimaiaQuiz() {
    var quizContainer = document.getElementById('tvkQuiz');
    var resultContainer = document.getElementById('tvkQuizResult');
    if (!quizContainer) return;
    quizState.step = 0; quizState.answers = {}; quizState.started = true; quizState.done = false;
    quizContainer.style.display = 'block';
    if (resultContainer) resultContainer.style.display = 'none';
    renderQuizStep(quizContainer, 0);
  }

  /* --- Hook into existing tvk widget --- */
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var target = mutation.target;
        if (target.id === 'tvkScreenQuiz' && target.classList.contains('tvk-screen--active')) {
          setTimeout(initKimaiaQuiz, 200);
        }
      }
    });
  });
  var quizScreen = document.getElementById('tvkScreenQuiz');
  if (quizScreen) observer.observe(quizScreen, { attributes: true });
  var goQuizBtns = document.querySelectorAll('#tvkGoQuiz, [data-action="quiz"]');
  goQuizBtns.forEach(function(btn) {
    btn.addEventListener('click', function() { setTimeout(initKimaiaQuiz, 300); });
  });
  window.kimaiaQuizInit = initKimaiaQuiz;

})();